export default {
  bookExperiencePanel: 'Панел за резервация на преживяване',
  calendarIcon: 'Икона на календар',
  coverImageForResource: 'Заглавно изображение за преживявания {{title}}',
  filterBy: 'Филтриране по {{filter}}',
  filterByDateRange: 'Филтриране по период от дати',
  gallery: 'Галерия',
  goBack: 'Обратно към предишната страница',
  hostUserIcon: 'икона на потребител домакин',
  imageOf: 'Изображение на {{title}}',
  interactiveMapAltText: 'Интерактивна карта с избираеми {{title}}',
  mediaSlides: 'Медийни слайдове',
  muteVideo: 'Заглушаване на видео',
  nextPhoto: 'Следваща снимка',
  noVideoPlayback: 'Няма възможност за възпроизвеждане на видео',
  pauseVideo: 'Пауза на видео',
  photoOf: 'снимка на {{name}}',
  playVideo: 'Възпроизвеждане на видео',
  previousPhoto: 'Предишна снимка',
  moreFiltersAndExperiences: 'Повече филтри и преживявания',
  reserveSelectedSlot: 'Резервирай избрания слот',
  reviewRating: 'Оценка на отзив {{rating}} от 5',
  overallReviewRating: 'Обща оценка на отзивите {{rating}} от 5',
  selectCountryCodeForPhoneNumber: 'Изберете код на държава за телефонен номер',
  selectDate: 'Изберете дата',
  selectParticipants: 'Изберете участници',
  selectSessionTime: 'Изберете час на сесията',
  unmuteVideo: 'Включване на звука на видео',
  viewShoppingCart: 'Преглед на количката',
  itemsInCart: '{{count}} артикула в количката',
  zoomIn: 'Приближаване',
  zoomOut: 'Отдалечаване',
  selectData: 'Изберете {{data}}',
  reserveName: 'Резервирай {{name}}',
  deleteReservation: 'Изтриване на резервация за {{experienceTitle}}',
  editParticipantsFor: 'Редактиране на участниците за {{experienceTitle}}',
  enterPromoCode: 'Въведете промо код',
  applyPromoCode: 'Приложи промо код',
  increaseAddOnAmount: 'Увеличаване на избраните {{addOn}}',
  decreaseAddOnAmount: 'Намаляване на избраните {{addOn}}',
  addOnModal: '{{addOn}} модален прозорец',
  moreInformationAboutAddOn: 'Повече информация за {{addOn}}',
  decreasePriceTierTickets: 'Намаляване на билетите за {{priceTier}}',
  increasePriceTierTickets: 'Увеличаване на билетите за {{priceTier}}',
  downloadFilename: 'Изтегляне на {{filename}}',
  viewFullDetailsDescription: 'Преглед на пълно описание с детайли',
  viewFullDescription: 'Преглед на пълно описание',
  closeModal: 'Затваряне на модален прозорец',
  hyattBanner: 'World Of Hyatt банер за ексклузивни членове',
  hyattBannerDesc:
    'Промоционален банер, показващ ексклузивни предимства и оферти, достъпни за членовете на програмата за лоялност World of Hyatt',
  previousSlide: 'Предишен слайд',
  nextSlide: 'Следващ слайд',
  paginationBulletMessage: 'Отиди на слайд',
  exitFullscreen: 'Изход от цял екран',
  enterFullscreen: 'Влизане в цял екран',
  videoSlide: 'Видео слайд',
  imageSlide: 'Слайд с изображение',
  of: 'от',
  noDescription: 'Без описание',
  mediaGallery: 'Карусел - Медийна галерия',
  dateSelector: 'Избор на дата',
  nextWeek: 'Следваща седмица',
  previousWeek: 'Предишна седмица',
  scheduleAgenda: 'Програма на графика',
  scheduleNav: 'Навигация на графика',
  scheduleViewSelector: 'Избор на изглед на графика',
  selectedDateAriaLabel: '{{date}}, избрано',
  tapToBookExperience: 'Резервирайте {{title}}',
  bookExperienceAriaLabel: 'Резервирайте {{title}}',
  joinWaitlistAriaLabel: 'Присъединете се към списъка с чакащи за {{title}}',
};
